<template>
  <div>
    <label
      for="years"
      class="font-weight-bold tourist-tax-pro-blue text-uppercase"
      >Seleziona anno</label
    >
    <v-select
      id="years"
      label="Seleziona"
      :items="years"
      v-model="yearModel"
      filled
      dense
      color="#0f0f0f"
    ></v-select>
  </div>
</template>

<script>
const range = (start, end) =>
  Array.from({ length: end - start + 1 }, (_, i) => start + i);

const yearsFrom = startYear => range(startYear, new Date().getFullYear());

export default {
  props: {
    value: {
      type: Number,
      required: false,
      default: new Date().getFullYear()
    }
  },

  data() {
    return {
      years: yearsFrom(2018)
    };
  },

  computed: {
    yearModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
